export const enum ThumbnailBackground {
  Transparent = 'transparent',
  LightBlue = '#f4fafe',
  LightBlueInfoPanel = '#f0f4f7',
}
